import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { url, propertySearchRoom } from '../config/app-config';
import { UserService } from 'src/app/core/services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class ReservationService {
  private _dataRespone: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  dataRespone$: Observable<any> = this._dataRespone.asObservable();
  constructor(private http: HttpClient, private userService: UserService) {}
  private _notiBookingSingleRoomType = new Subject<void>();
  private _bookingRoomType = new Subject<void>();
  public notiBookingSingleRoomType$ =
    this._notiBookingSingleRoomType.asObservable();

  createReservation(
    booked_room_list: any,
    paramsInput: any,
    user_id: string
  ): Observable<any> {
    const body = {
      booked_rooms_list: booked_room_list,
      user_id: user_id,
    };
    const params = new HttpParams({ fromObject: paramsInput as any });
    return this.http.post<any>(`${url}/reservation/reservations`, body, {
      params: paramsInput,
    });
  }

  setDataRespone(data: any) {
    this._dataRespone.next(data);
  }

  getDataRespone() {
    return this.dataRespone$;
  }

  clearData() {
    this._dataRespone.next(null);
  }

  notiBookingSingleRoomType(data: any) {
    this._notiBookingSingleRoomType.next(data);
  }

  getBookingSingleRoomType() {
    return this.notiBookingSingleRoomType$;
  }

  setBookingRoomType(data: any) {
    this._bookingRoomType.next(data);
  }

  getBookingRoomType() {
    return this._bookingRoomType.asObservable();
  }
}
